<template>
  <div class="col-12">
    <div class="row">
      <div v-if="!propEsconderCampos.cns"
           class="col-sm-3 col-lg-2">
        <div class="form-group">
          <label class="label"
                 for="cns">CNS</label>
          <input id="cns"
                 v-model="cns"
                 v-validate="{min:6, max:6}"
                 class="form-control form-control-sm"
                 :class="{ 'is-invalid': errors.has('cns') }"
                 name="cns"
                 placeholder="0000000"
                 type="tel"
                 @change="cnsChanged">
          <small v-if="errors.has('cns')"
                 class="invalid-feedback">{{ errors.first('cns') }}</small>
        </div>
      </div>

      <div v-if="!propEsconderCampos.uf"
           class="col-2">
        <div class="form-group">
          <label for="cidade">UF</label>
          <multiselect v-model="estado"
                       :tabindex="!!(cns) ? -1 : 0"
                       :options="listas.estados"
                       :show-labels="false"
                       placeholder="Selecione"
                       name="cidade"
                       label="uf"
                       track-by="uf"
                       @select="ufChanged" />
        </div>
      </div>

      <div v-if="!propEsconderCampos.cidade"
           class="col">
        <div class="form-group">
          <label for="crc_city">Cidade</label>
          <multiselect v-model="cidade"
                       :tabindex="!!(cns) ? -1 : 0"
                       :disabled="estado == null"
                       :options="citiesFiltered"
                       :show-labels="false"
                       label="nome"
                       track-by="ibge"
                       placeholder="Selecione"
                       @close="cityChanged" />
        </div>
      </div>
      <!-- :loading="loading" -->
      <div v-if="!propEsconderCampos.cartorio"
           class="col">
        <div class="form-group">
          <label for="notary">Cartório</label>
          <multiselect v-model="cartorio"
                       :tabindex="!!(cns) ? -1 : 0"
                       :options="listas.cartorios"
                       :show-labels="false"
                       placeholder="Selecione"
                       name="cartorio"
                       label="nome"
                       track-by="nome"
                       @select="setCartorio" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // Services
  import CartorioService from "@/services/CartorioService"
  import EnderecosService from "@/services/Enderecos"

  export default {
    name: "PesquisarCartorio",
    props: {
      propEsconderCampos: { type: Object, default: () => { return {} }},
      propDados: { type: Object, default: () => { return {} }},
      propRegistro: { type: Object, default: () => { return {} }},
    },
    data () {
      return {
        ufUpdate: true,
        cidade: null,
        estado: {},
        cartorio: {},
        cns: null,
        listas: { estados: [], cidades: [], cartorios: [] },
        loading: false,
      }
    },
    computed: {
      citiesFiltered () {

        if (this.ufUpdate && this.estado && this.estado.codigo) {
          return this.listas.cidades.filter(city => city.nome === 'Outro' || city.codigo_uf == this.estado.codigo)
        }

        return this.listas.cidades
      },
    },
    async beforeMount () {
      const estados = await EnderecosService.getStates()
      this.listas.estados = estados.sort((a,b) => { return (a.nome > b.nome) ? 1 : -1 })
      this.listas.cidades = await EnderecosService.getCities()

      if (this.propRegistro) {
        this.cartorio = this.propRegistro.cartorio || { isEmpty: true }

        if (this.cartorio.isEmpty) return

        const cidade = this.propRegistro.cidade || this.cartorio && this.cartorio.endereco ? this.cartorio.endereco.cidade : null

        this.cidade = this.listas.cidades.find(city => city.nome === 'Outro' || city.nome == cidade)
        this.estado = this.listas.estados.find(state => state.uf == this.propRegistro.uf)
      }
    },
    methods: {
      fixCnsLenght (cartorio) {
        if (cartorio) {
          let cns = cartorio.cnj || cartorio.cns
          let cnsArr = String(cns).split('')
          if (cnsArr.length < 6) {
            while (cnsArr.length < 6) {
              cnsArr.unshift('0')
            }
            cns = cnsArr.join('')
          }
          return cns
        }
      },
      setCartorio (cartorio = { }) {

        this.cns = this.fixCnsLenght(cartorio)
        this.updated()
        this.cartorio = cartorio
        this.$emit('cartorioChanged', cartorio)
      },
      cnsChanged () {
        this.$validator.validate().then(res => {
          if (!res) { return }
          this.estado = {}
          this.cidade = {}
          this.cartorio = {}
          this.listas.cartorios = []
          this.busca('cns')
        })

        this.$emit('cnsChanged', this.cns)
      },
      ufChanged () {
        this.ufUpdate = true

        this.cns = null
        this.cidade = {}
        this.cartorio = {}
        this.listas.cartorios = []

        this.updated()
        this.$emit('ufChanged', this.estado)
      },
      cityChanged	() {
        this.cns = null
        this.cartorio = {}
        this.busca('ibge')

        this.updated()
        this.$emit('cityChanged', this.cidade)

        this.ufUpdate = false
      },
      async busca (tipo) {
        this.loading = true

        let query = {
          cns: (tipo === 'cns' && this.cns) ? this.cns : null,
          ibge: (tipo !== 'cns' && this.cidade) ? this.cidade.ibge : null
        }

        this.listas.cartorios = []
        let cartorio = {}
        let isList = false

        objSwal.info.title = ''

        try {
          const { data } = await CartorioService.pesquisarCartorios(query)

          isList = data instanceof Array

          if (isList) {
            this.listas.cartorios = data[0] && data[0].cartorios || []

            cartorio = this.listas.cartorios[0] || { isEmpty: true }

          } else {

            cartorio = data || { isEmpty: true }
          }

          if (cartorio.isEmpty === true) {

            objSwal.info.text = "Nenhum cartório encontrado!"
            Swal.fire(objSwal.info)

            return
          } else {

            let cidade = cartorio.cidade
            let estado = cartorio.estado

            if (cidade && estado && cartorio.isEmpty !== true) {

              this.estado = this.listas.estados.find(state => state.uf === estado)
              this.cidade = this.listas.cidades.find(city => city.nome === cidade)
            } else {

              objSwal.info.text = "Cartório encontrado porém os dados estão incompletos!"
              Swal.fire(objSwal.info)
            }

            this.setCartorio(cartorio)

            this.updated()
          }

          this.loading = false

        } catch (e) {

          objSwal.error.title = 'Erro na busca!'
          objSwal.error.text = `Houve algum problema na comunicação com o serviço da busca: ${e.message}`
          Swal.fire(objSwal.error)
        }

      },
      updated () {
        this.$emit('updated', {
          cidade: this.cidade,
          estado: this.estado,
          cartorio: this.cartorio,
        })
      },
    }
  }
</script>

<style scoped>

</style>
